import { render, staticRenderFns } from "./PendingLoanRequestApprovals.vue?vue&type=template&id=317aaea0&"
import script from "./PendingLoanRequestApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingLoanRequestApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports